import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  constructor() {}
  scrollToElementById(id: string) {
    const element = this.__getElementById(id);
    if (element) {
      this.scrollToTargetElement(element);
    }
  }

  elementByIdExists(id) {
    const element = this.__getElementById(id);
    if (element) {
      return true;
    } else {
      return false;
    }
  }

  private __getElementById(id: string): HTMLElement {
    const element = document.getElementById(id);
    return element;
  }

  scrollToElement(element: HTMLElement) {
    element.scrollIntoView({ behavior: 'smooth' });
  }

  scrollToTargetElement(element) {
    element.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
  }
}
